function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { utils as utils_exports, registerButton, DEFAULTS, TypedEvent, AbstractButton, AbstractConfigurablePlugin, events as events_exports$1, CONSTANTS as constants_exports, PSVError } from '../core/index.module.js';
import { MathUtils, Vector2, SplineCurve } from '../../three/build/three.module.js';

/*!
 * PhotoSphereViewer.AutorotatePlugin 5.6.0
 * @copyright 2024 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */
var __defProp = Object.defineProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

// src/events.ts
var events_exports = {};
__export(events_exports, {
  AutorotateEvent: function AutorotateEvent() {
    return _AutorotateEvent2;
  }
});
var _AutorotateEvent = /*#__PURE__*/function (_TypedEvent) {
  _inherits(_AutorotateEvent, _TypedEvent);
  var _super = _createSuper(_AutorotateEvent);
  /** @internal */
  function _AutorotateEvent(autorotateEnabled) {
    var _this;
    _classCallCheck(this, _AutorotateEvent);
    _this = _super.call(this, _AutorotateEvent.type);
    _this.autorotateEnabled = autorotateEnabled;
    return _this;
  }
  return _createClass(_AutorotateEvent);
}(TypedEvent);
_AutorotateEvent.type = "autorotate";
var _AutorotateEvent2 = _AutorotateEvent;

// src/icons/play-active.svg
var play_active_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 41" overflow="visible"><g fill="currentColor" transform-origin="center" transform="scale(1.3)"><path d="M40.5 14.1c-.1-.1-1.2-.5-2.898-1-.102 0-.202-.1-.202-.2C34.5 6.5 28 2 20.5 2S6.6 6.5 3.7 12.9c0 .1-.1.1-.2.2-1.7.6-2.8 1-2.9 1l-.6.3v12.1l.6.2c.1 0 1.1.399 2.7.899.1 0 .2.101.2.199C6.3 34.4 12.9 39 20.5 39c7.602 0 14.102-4.6 16.9-11.1 0-.102.1-.102.199-.2 1.699-.601 2.699-1 2.801-1l.6-.3V14.3l-.5-.2zM6.701 11.5C9.7 7 14.8 4 20.5 4c5.8 0 10.9 3 13.8 7.5.2.3-.1.6-.399.5-3.799-1-8.799-2-13.6-2-4.7 0-9.5 1-13.2 2-.3.1-.5-.2-.4-.5zM25.1 20.3L18.7 24c-.3.2-.7 0-.7-.5v-7.4c0-.4.4-.6.7-.4l6.399 3.8c.301.1.301.6.001.8zm9.4 8.901A16.421 16.421 0 0 1 20.5 37c-5.9 0-11.1-3.1-14-7.898-.2-.302.1-.602.4-.5 3.9 1 8.9 2.1 13.6 2.1 5 0 9.9-1 13.602-2 .298-.1.5.198.398.499z"/></g><!--Created by Nick Bluth from the Noun Project--></svg>\n';

// src/icons/play.svg
var play_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 41" overflow="visible"><g fill="currentColor" transform-origin="center" transform="scale(1.3)"><path d="M40.5 14.1c-.1-.1-1.2-.5-2.899-1-.101 0-.2-.1-.2-.2C34.5 6.5 28 2 20.5 2S6.6 6.5 3.7 12.9c0 .1-.1.1-.2.2-1.7.6-2.8 1-2.9 1l-.6.3v12.1l.6.2c.1 0 1.1.4 2.7.9.1 0 .2.1.2.199C6.3 34.4 12.9 39 20.5 39c7.601 0 14.101-4.6 16.9-11.1 0-.101.1-.101.2-.2 1.699-.6 2.699-1 2.8-1l.6-.3V14.3l-.5-.2zM20.5 4c5.8 0 10.9 3 13.8 7.5.2.3-.1.6-.399.5-3.8-1-8.8-2-13.6-2-4.7 0-9.5 1-13.2 2-.3.1-.5-.2-.4-.5C9.7 7 14.8 4 20.5 4zm0 33c-5.9 0-11.1-3.1-14-7.899-.2-.301.1-.601.4-.5 3.9 1 8.9 2.1 13.6 2.1 5 0 9.9-1 13.601-2 .3-.1.5.2.399.5A16.422 16.422 0 0 1 20.5 37zm18.601-12.1c0 .1-.101.3-.2.3-2.5.9-10.4 3.6-18.4 3.6-7.1 0-15.6-2.699-18.3-3.6C2.1 25.2 2 25 2 24.9V16c0-.1.1-.3.2-.3 2.6-.9 10.6-3.6 18.2-3.6 7.5 0 15.899 2.7 18.5 3.6.1 0 .2.2.2.3v8.9z"/><path d="M18.7 24l6.4-3.7c.3-.2.3-.7 0-.8l-6.4-3.8c-.3-.2-.7 0-.7.4v7.4c0 .5.4.7.7.5z"/></g><!--Created by Nick Bluth from the Noun Project--></svg>\n';

// src/AutorotateButton.ts
var AutorotateButton = /*#__PURE__*/function (_AbstractButton) {
  _inherits(AutorotateButton, _AbstractButton);
  var _super2 = _createSuper(AutorotateButton);
  function AutorotateButton(navbar) {
    var _this2$plugin;
    var _this2;
    _classCallCheck(this, AutorotateButton);
    _this2 = _super2.call(this, navbar, {
      className: "psv-autorotate-button",
      hoverScale: true,
      collapsable: true,
      tabbable: true,
      icon: play_default,
      iconActive: play_active_default
    });
    _this2.plugin = _this2.viewer.getPlugin("autorotate");
    (_this2$plugin = _this2.plugin) === null || _this2$plugin === void 0 ? void 0 : _this2$plugin.addEventListener(_AutorotateEvent2.type, _assertThisInitialized(_this2));
    return _this2;
  }
  _createClass(AutorotateButton, [{
    key: "destroy",
    value: function destroy() {
      var _this$plugin;
      (_this$plugin = this.plugin) === null || _this$plugin === void 0 ? void 0 : _this$plugin.removeEventListener(_AutorotateEvent2.type, this);
      _get(_getPrototypeOf(AutorotateButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "isSupported",
    value: function isSupported() {
      return !!this.plugin;
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _AutorotateEvent2) {
        this.toggleActive(e.autorotateEnabled);
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      if (this.plugin.isEnabled()) {
        this.plugin.config.autostartOnIdle = false;
      }
      this.plugin.toggle();
    }
  }]);
  return AutorotateButton;
}(AbstractButton);
AutorotateButton.id = "autorotate";
var getConfig = utils_exports.getConfigParser({
  autostartDelay: 2e3,
  autostartOnIdle: true,
  autorotateSpeed: utils_exports.parseSpeed("2rpm"),
  autorotatePitch: null,
  autorotateZoomLvl: null,
  keypoints: null,
  startFromClosest: true
}, {
  autostartOnIdle: function autostartOnIdle(_autostartOnIdle, _ref) {
    var rawConfig = _ref.rawConfig;
    if (_autostartOnIdle && utils_exports.isNil(rawConfig.autostartDelay)) {
      utils_exports.logWarn("autostartOnIdle requires a non null autostartDelay");
      return false;
    }
    return _autostartOnIdle;
  },
  autorotateSpeed: function autorotateSpeed(_autorotateSpeed) {
    return utils_exports.parseSpeed(_autorotateSpeed);
  },
  autorotatePitch: function autorotatePitch(_autorotatePitch) {
    if (!utils_exports.isNil(_autorotatePitch)) {
      return utils_exports.parseAngle(_autorotatePitch, true);
    }
    return null;
  },
  autorotateZoomLvl: function autorotateZoomLvl(_autorotateZoomLvl) {
    if (!utils_exports.isNil(_autorotateZoomLvl)) {
      return MathUtils.clamp(_autorotateZoomLvl, 0, 100);
    }
    return null;
  }
});
var NUM_STEPS = 16;
function serializePt(position) {
  return [position.yaw, position.pitch];
}
var AutorotatePlugin = /*#__PURE__*/function (_AbstractConfigurable) {
  _inherits(AutorotatePlugin, _AbstractConfigurable);
  var _super3 = _createSuper(AutorotatePlugin);
  function AutorotatePlugin(viewer, config) {
    var _this3;
    _classCallCheck(this, AutorotatePlugin);
    _this3 = _super3.call(this, viewer, config);
    _this3.state = {
      initialStart: true,
      /** if the automatic rotation is enabled */
      enabled: false,
      /** current index in keypoints */
      idx: -1,
      /** curve between idx and idx + 1 */
      curve: [],
      /** start point of the current step */
      startStep: null,
      /** end point of the current step */
      endStep: null,
      /** start time of the current step  */
      startTime: null,
      /** expected duration of the step */
      stepDuration: null,
      /** time remaining for the pause */
      remainingPause: null,
      /** previous timestamp in render loop */
      lastTime: null,
      /** currently displayed tooltip */
      tooltip: null
    };
    _this3.state.initialStart = !utils_exports.isNil(_this3.config.autostartDelay);
    return _this3;
  }
  /**
   * @internal
   */
  _createClass(AutorotatePlugin, [{
    key: "init",
    value: function init() {
      _get(_getPrototypeOf(AutorotatePlugin.prototype), "init", this).call(this);
      this.video = this.viewer.getPlugin("video");
      this.markers = this.viewer.getPlugin("markers");
      if (this.config.keypoints) {
        this.setKeypoints(this.config.keypoints);
        delete this.config.keypoints;
      }
      this.viewer.addEventListener(events_exports$1.StopAllEvent.type, this);
      this.viewer.addEventListener(events_exports$1.BeforeRenderEvent.type, this);
      if (!this.video) {
        this.viewer.addEventListener(events_exports$1.KeypressEvent.type, this);
      }
    }
    /**
     * @internal
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(events_exports$1.StopAllEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.BeforeRenderEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.KeypressEvent.type, this);
      delete this.video;
      delete this.markers;
      delete this.keypoints;
      _get(_getPrototypeOf(AutorotatePlugin.prototype), "destroy", this).call(this);
    }
    /**
     * @internal
     */
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case events_exports$1.StopAllEvent.type:
          this.stop();
          break;
        case events_exports$1.BeforeRenderEvent.type:
          {
            this.__beforeRender(e.timestamp);
            break;
          }
        case events_exports$1.KeypressEvent.type:
          if (e.key === constants_exports.KEY_CODES.Space && this.viewer.state.keyboardEnabled) {
            this.toggle();
            e.preventDefault();
          }
          break;
      }
    }
    /**
     * Changes the keypoints
     * @throws {@link PSVError} if the configuration is invalid
     */
  }, {
    key: "setKeypoints",
    value: function setKeypoints(keypoints) {
      var _this4 = this;
      if (!keypoints) {
        this.keypoints = null;
      } else {
        if (keypoints.length < 2) {
          throw new PSVError("At least two points are required");
        }
        this.keypoints = keypoints.map(function (pt, i) {
          var keypoint = {
            position: null,
            markerId: null,
            pause: 0,
            tooltip: null
          };
          var position;
          if (typeof pt === "string") {
            keypoint.markerId = pt;
          } else if (utils_exports.isExtendedPosition(pt)) {
            position = pt;
          } else {
            keypoint.markerId = pt.markerId;
            keypoint.pause = pt.pause;
            position = pt.position;
            if (pt.tooltip && _typeof(pt.tooltip) === "object") {
              keypoint.tooltip = pt.tooltip;
            } else if (typeof pt.tooltip === "string") {
              keypoint.tooltip = {
                content: pt.tooltip
              };
            }
          }
          if (keypoint.markerId) {
            if (!_this4.markers) {
              throw new PSVError("Keypoint #".concat(i, " references a marker but the markers plugin is not loaded"));
            }
            var marker = _this4.markers.getMarker(keypoint.markerId);
            keypoint.position = serializePt(marker.state.position);
          } else if (position) {
            keypoint.position = serializePt(_this4.viewer.dataHelper.cleanPosition(position));
          } else {
            throw new PSVError("Keypoint #".concat(i, " is missing marker or position"));
          }
          return keypoint;
        });
      }
      if (this.isEnabled()) {
        this.stop();
        this.start();
      }
    }
    /**
     * Checks if the automatic rotation is enabled
     */
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this.state.enabled;
    }
    /**
     * Starts the automatic rotation
     */
  }, {
    key: "start",
    value: function start() {
      if (this.isEnabled()) {
        return;
      }
      this.viewer.stopAll();
      if (!this.keypoints) {
        this.__animate();
      } else if (this.config.startFromClosest) {
        this.__shiftKeypoints();
      }
      this.state.initialStart = false;
      this.state.enabled = true;
      this.dispatchEvent(new _AutorotateEvent2(true));
    }
    /**
     * Stops the automatic rotation
     */
  }, {
    key: "stop",
    value: function stop() {
      if (!this.isEnabled()) {
        return;
      }
      this.__hideTooltip();
      this.__reset();
      this.viewer.stopAnimation();
      this.viewer.dynamics.position.stop();
      this.viewer.dynamics.zoom.stop();
      this.state.enabled = false;
      this.dispatchEvent(new _AutorotateEvent2(false));
    }
    /**
     * Starts or stops the automatic rotation
     */
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.isEnabled()) {
        this.stop();
      } else {
        this.start();
      }
    }
    /**
     * @internal
     */
  }, {
    key: "reverse",
    value: function reverse() {
      if (this.isEnabled() && !this.keypoints) {
        this.config.autorotateSpeed = -this.config.autorotateSpeed;
        this.__animate();
      }
    }
    /**
     * Launches the standard animation
     */
  }, {
    key: "__animate",
    value: function __animate() {
      var _this5 = this;
      var p;
      if (!utils_exports.isNil(this.config.autorotateZoomLvl)) {
        p = this.viewer.animate({
          zoom: this.config.autorotateZoomLvl,
          // "2" is magic, and kinda related to the "PI/4" in getAnimationProperties()
          speed: "".concat(this.viewer.config.zoomSpeed * 2, "rpm")
        });
      } else {
        p = Promise.resolve(true);
      }
      p.then(function (done) {
        if (done) {
          var _this5$config$autorot;
          _this5.viewer.dynamics.position.roll({
            yaw: _this5.config.autorotateSpeed < 0
          }, Math.abs(_this5.config.autorotateSpeed / _this5.viewer.config.moveSpeed));
          _this5.viewer.dynamics.position["goto"]({
            pitch: (_this5$config$autorot = _this5.config.autorotatePitch) !== null && _this5$config$autorot !== void 0 ? _this5$config$autorot : _this5.viewer.config.defaultPitch
          }, Math.abs(_this5.config.autorotateSpeed / _this5.viewer.config.moveSpeed));
        }
      });
    }
    /**
     * Resets all the curve variables
     */
  }, {
    key: "__reset",
    value: function __reset() {
      this.state.idx = -1;
      this.state.curve = [];
      this.state.startStep = null;
      this.state.endStep = null;
      this.state.startTime = null;
      this.state.stepDuration = null;
      this.state.remainingPause = null;
      this.state.lastTime = null;
      this.state.tooltip = null;
    }
    /**
     * Automatically starts if the delay is reached
     * Performs keypoints animation
     */
  }, {
    key: "__beforeRender",
    value: function __beforeRender(timestamp) {
      if ((this.state.initialStart || this.config.autostartOnIdle) && this.viewer.state.idleTime > 0 && timestamp - this.viewer.state.idleTime > this.config.autostartDelay) {
        this.start();
      }
      if (this.isEnabled() && this.keypoints) {
        if (!this.state.startTime) {
          this.state.endStep = serializePt(this.viewer.getPosition());
          this.__nextStep();
          this.state.startTime = timestamp;
          this.state.lastTime = timestamp;
        }
        this.__nextFrame(timestamp);
      }
    }
  }, {
    key: "__shiftKeypoints",
    value: function __shiftKeypoints() {
      var _this$keypoints;
      var currentPosition = serializePt(this.viewer.getPosition());
      var index = this.__findMinIndex(this.keypoints, function (keypoint) {
        return utils_exports.greatArcDistance(keypoint.position, currentPosition);
      });
      (_this$keypoints = this.keypoints).push.apply(_this$keypoints, _toConsumableArray(this.keypoints.splice(0, index)));
    }
  }, {
    key: "__incrementIdx",
    value: function __incrementIdx() {
      this.state.idx++;
      if (this.state.idx === this.keypoints.length) {
        this.state.idx = 0;
      }
    }
  }, {
    key: "__showTooltip",
    value: function __showTooltip() {
      var keypoint = this.keypoints[this.state.idx];
      if (keypoint.tooltip) {
        var position = this.viewer.dataHelper.vector3ToViewerCoords(this.viewer.state.direction);
        this.state.tooltip = this.viewer.createTooltip({
          content: keypoint.tooltip.content,
          position: keypoint.tooltip.position,
          top: position.y,
          left: position.x
        });
      } else if (keypoint.markerId) {
        var marker = this.markers.getMarker(keypoint.markerId);
        marker.showTooltip();
        this.state.tooltip = marker.tooltip;
      }
    }
  }, {
    key: "__hideTooltip",
    value: function __hideTooltip() {
      if (this.state.tooltip) {
        var keypoint = this.keypoints[this.state.idx];
        if (keypoint.tooltip) {
          this.state.tooltip.hide();
        } else if (keypoint.markerId) {
          var marker = this.markers.getMarker(keypoint.markerId);
          marker.hideTooltip();
        }
        this.state.tooltip = null;
      }
    }
  }, {
    key: "__nextPoint",
    value: function __nextPoint() {
      var workPoints = [];
      if (this.state.idx === -1) {
        var currentPosition = serializePt(this.viewer.getPosition());
        workPoints.push(currentPosition, currentPosition, this.keypoints[0].position, this.keypoints[1].position);
      } else {
        for (var i = -1; i < 3; i++) {
          var keypoint = this.state.idx + i < 0 ? this.keypoints[this.keypoints.length - 1] : this.keypoints[(this.state.idx + i) % this.keypoints.length];
          workPoints.push(keypoint.position);
        }
      }
      var workVectors = [new Vector2(workPoints[0][0], workPoints[0][1])];
      var k = 0;
      for (var _i = 1; _i <= 3; _i++) {
        var d = workPoints[_i - 1][0] - workPoints[_i][0];
        if (d > Math.PI) {
          k += 1;
        } else if (d < -Math.PI) {
          k -= 1;
        }
        if (k !== 0 && _i === 1) {
          workVectors[0].x -= k * 2 * Math.PI;
          k = 0;
        }
        workVectors.push(new Vector2(workPoints[_i][0] + k * 2 * Math.PI, workPoints[_i][1]));
      }
      var curve = new SplineCurve(workVectors).getPoints(NUM_STEPS * 3).map(function (p) {
        return [p.x, p.y];
      });
      this.state.curve = curve.slice(NUM_STEPS + 1, NUM_STEPS * 2 + 1);
      if (this.state.idx !== -1) {
        this.state.remainingPause = this.keypoints[this.state.idx].pause;
        if (this.state.remainingPause) {
          this.__showTooltip();
        } else {
          this.__incrementIdx();
        }
      } else {
        this.__incrementIdx();
      }
    }
  }, {
    key: "__nextStep",
    value: function __nextStep() {
      if (this.state.curve.length === 0) {
        this.__nextPoint();
        this.state.endStep[0] = utils_exports.parseAngle(this.state.endStep[0]);
      }
      this.state.startStep = this.state.endStep;
      this.state.endStep = this.state.curve.shift();
      var distance = utils_exports.greatArcDistance(this.state.startStep, this.state.endStep);
      this.state.stepDuration = distance * 1e3 / Math.abs(this.config.autorotateSpeed);
      if (distance === 0) {
        this.__nextStep();
      }
    }
  }, {
    key: "__nextFrame",
    value: function __nextFrame(timestamp) {
      var ellapsed = timestamp - this.state.lastTime;
      this.state.lastTime = timestamp;
      if (this.state.remainingPause) {
        this.state.remainingPause = Math.max(0, this.state.remainingPause - ellapsed);
        if (this.state.remainingPause > 0) {
          return;
        } else {
          this.__hideTooltip();
          this.__incrementIdx();
          this.state.startTime = timestamp;
        }
      }
      var progress = (timestamp - this.state.startTime) / this.state.stepDuration;
      if (progress >= 1) {
        this.__nextStep();
        progress = 0;
        this.state.startTime = timestamp;
      }
      this.viewer.rotate({
        yaw: this.state.startStep[0] + (this.state.endStep[0] - this.state.startStep[0]) * progress,
        pitch: this.state.startStep[1] + (this.state.endStep[1] - this.state.startStep[1]) * progress
      });
    }
  }, {
    key: "__findMinIndex",
    value: function __findMinIndex(array, mapper) {
      var idx = 0;
      var current = Number.MAX_VALUE;
      array.forEach(function (item, i) {
        var value = mapper(item);
        if (value < current) {
          current = value;
          idx = i;
        }
      });
      return idx;
    }
  }]);
  return AutorotatePlugin;
}(AbstractConfigurablePlugin);
AutorotatePlugin.id = "autorotate";
AutorotatePlugin.VERSION = "5.6.0";
AutorotatePlugin.configParser = getConfig;
AutorotatePlugin.readonlyOptions = ["keypoints"];

// src/index.ts
registerButton(AutorotateButton, "start");
DEFAULTS.lang[AutorotateButton.id] = "Automatic rotation";
export { AutorotatePlugin, events_exports as events };
//# sourceMappingURL=index.module.js.map
